const singleProperty = {
  init: function () {
    this.map.init();
    this.related();
  },

  map: {
    el: $(".property__map__el"),
    default: "",
    geocoder: false,
    contents: false,
    pin: false,
    zoom: 15,

    init: function () {
      singleProperty.map.base();
    },

    base: function () {
      const mapEl = singleProperty.map.el;

      if (mapEl.data("zoom")) {
        singleProperty.map.zoom = parseInt(mapEl.data("zoom"));
      }

      if (mapEl.data("pin")) {
        singleProperty.map.pin = mapEl.data("pin");
      }

      singleProperty.map.geocoder = new google.maps.Geocoder();

      singleProperty.map.default = new google.maps.LatLng(
        56.9715833,
        23.989082
      );

      singleProperty.map.contents = new google.maps.Map(mapEl[0], {
        zoom: singleProperty.map.zoom,
        center: singleProperty.map.default,
        disableDefaultUI: false,
        scrollwheel: false,
        draggable: true,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff" }, { lightness: 17 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 18 }],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 16 }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#dedede" }, { lightness: 21 }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              { visibility: "on" },
              { color: "#ffffff" },
              { lightness: 16 },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              { saturation: 36 },
              { color: "#333333" },
              { lightness: 40 },
            ],
          },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#fefefe" }, { lightness: 20 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
          },
        ],
      });

      var location = new google.maps.LatLng(
        mapEl.data("lat"),
        mapEl.data("lng")
      );
      singleProperty.map.marker(location);
    },

    marker: function (location) {
      singleProperty.map.contents.setCenter(location);

      var marker_options = {
        map: singleProperty.map.contents,
        position: location,
        animation: google.maps.Animation.DROP,
      };

      if (singleProperty.map.pin) {
        marker_options.icon = singleProperty.map.pin;
      }

      var marker = new google.maps.Marker(marker_options);
    },
  },

  related: function () {
    $(".property-related__slider").slick({
      slidesToShow: 4,
      appendArrows: $(".property-related__nav"),
      prevArrow:
        '<button class="slick-prev" aria-label="prev">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z" transform="translate(9.867 16) rotate(180)"/></svg>' +
        "</button>",
      nextArrow:
        '<button class="slick-next" aria-label="next">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z"/></svg>' +
        "</button>",
      infinite: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      rows: 0,
    });
  },
};

export default singleProperty;
